/* eslint-disable @typescript-eslint/naming-convention */
export enum directionsEnum {
    top = 'top',
    right = 'right',
    bottom = 'bottom',
    left = 'left'
}
